document.addEventListener("DOMContentLoaded", function () {
  const filterForm =
    document.querySelector("#FilterSortPanel form") ||
    document.querySelector("#FilterSortPanel");
  const productGrid = document.querySelector("#ProductGridContainer");

  if (!filterForm || !productGrid) return;

  function getFilterParams() {
    const params = new URLSearchParams();
    filterForm
      .querySelectorAll(
        'input[type="checkbox"], input[type="radio"], input[type="number"]'
      )
      .forEach((input) => {
        if (
          (input.type === "checkbox" || input.type === "radio") &&
          !input.checked
        )
          return;
        if (input.name && input.value !== "") {
          params.append(input.name, input.value);
        }
      });
    return params.toString();
  }

  function reloadColorVariantCount(params) {
    const container = document.getElementById("ColorVariantCountContainer");
    if (!container) return;

    const url = `${window.location.pathname}?section_id=color-variant-count&${params}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        container.innerHTML = html;
      })
      .catch((err) => {
        console.error("Fehler beim Nachladen des Farbvariantenzählers:", err);
      });
  }

  function fetchFilteredProducts() {
    const params = getFilterParams();
    const url = `${window.location.pathname}?section_id=main-collection-product-grid&${params}`;

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newGrid = doc.querySelector("#ProductGridContainer");
        if (newGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params}`
          );
        }

        reloadColorVariantCount(params);
        initSwipers();
      })
      .catch((err) => console.error("Fehler beim Laden der Produkte:", err));
  }

  filterForm
    .querySelectorAll(
      'input[type="checkbox"], input[type="radio"], input[type="number"]'
    )
    .forEach((input) => {
      input.addEventListener("change", () => {
        fetchFilteredProducts();
      });
    });
});

function initSwipers(){

  const productGridConfig = {
    slidesPerView: 2,
    grid: {
      rows: 2,
      fill: "row",
    },
    spaceBetween: 0,
    allowTouchMove: false,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        grid: {
          rows: 1,
        },
      },
    },
  };

  // Product Image Swiper configuration
  const productImageConfig = {
    loop: true,
    nested: true,
    //effect: 'fade',
    fadeEffect: {
      //crossFade: true
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  
  const productGridSwiper = new Swiper(
      ".finkid-products-swiper .swiper-container",
      productGridConfig
    );

    // Product Image Swipers
    const productImageSwipers = document.querySelectorAll(
      ".product-image-swiper"
    );

   productImageSwipers.forEach((element) => {
      new Swiper(element, productImageConfig);
    });
}

function toggle_filter_sort_panel(event) {
  const panel = document.getElementById("FilterSortPanel");
  if (!panel) return;

  const isOpen = panel.classList.contains("open");

  // Viewport Breite prüfen
  const isMobile = window.innerWidth < 750; // oder dein Breakpoint für mobile

  // Wenn kein Event übergeben wurde (z. B. bei Button-Klick), normal togglen
  if (!event) {
    panel.classList.toggle("open");
    if (panel.classList.contains("open") && isMobile) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return;
  }

  // Nur schließen, wenn auf das äußere Element selbst geklickt wurde
  if (event.target === event.currentTarget) {
    panel.classList.remove("open");
    if (isMobile) {
      document.body.classList.remove("overflow-hidden");
    }
  }
}


function resetAllFilters() {
  const filterForm =
    document.querySelector("#FilterSortPanel form") ||
    document.querySelector("#FilterSortPanel");
  const productGrid = document.querySelector("#ProductGridContainer");
  if (!filterForm || !productGrid) return;

  filterForm.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.checked = false;
  });

  filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
    input.value = "";
  });

  const params = new URLSearchParams();
  filterForm
    .querySelectorAll(
      'input[type="checkbox"], input[type="radio"], input[type="number"]'
    )
    .forEach((input) => {
      if (
        (input.type === "checkbox" || input.type === "radio") &&
        !input.checked
      )
        return;
      if (input.name && input.value !== "") {
        params.append(input.name, input.value);
      }
    });

  const url = `${
    window.location.pathname
  }?section_id=main-collection-product-grid&${params.toString()}`;

  fetch(url)
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newGrid = doc.querySelector("#ProductGridContainer");
      if (newGrid) {
        productGrid.innerHTML = newGrid.innerHTML;
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${params}`
        );
      }

      reloadColorVariantCount(params);
    })
    .catch((err) => console.error("Fehler beim Laden der Produkte:", err));
}

function toggleMobileFilterDrawer() {
  const drawer = document.getElementById("MobileFilterDrawer");
  if (drawer) {
    drawer.classList.toggle("open");
  }
}

